/**
 * Layout das rotinas em modo coletor.
 *
 * Em modo coletor (pageStore ou dispositivo mobile/nativo), formulários usam
 * `collector-option` (topbar com voltar). Exceções explícitas:
 * - `/login` → empty
 * - `/` (home) → collector | default (escolhido na própria página)
 * - páginas com `layout: "default"` → desktop (gestão, logística, etc.)
 * - páginas com `layout: "empty"` ou `false` → mantém
 * - páginas com `layout: "collector"` → home/menu do coletor
 *
 * Preferência: cada formulário de coletor também declara
 * `definePageMeta({ layout: "collector-option" })` (ver `.agent/rules/layout.md`).
 * Este middleware cobre páginas esquecidas e deep-link no coletor.
 */
export default defineNuxtRouteMiddleware((to) => {
	if (to.path === "/login") return;
	if (to.path === "/" || to.name === "index") return;

	const layoutAtual = to.meta.layout;

	// Respeita layouts explícitos que não são de formulário de coletor.
	if (
		layoutAtual === "empty" ||
		layoutAtual === "default" ||
		layoutAtual === false ||
		layoutAtual === "collector"
	) {
		return;
	}

	// Já declarado na página.
	if (layoutAtual === "collector-option") return;

	const pageStore = usePageStore();
	let modoColetor = pageStore.isCollector();

	if (import.meta.client) {
		try {
			const deviceStore = useDeviceStore();
			if (deviceStore.isMobile || deviceStore.isNative) {
				modoColetor = true;
			}
		} catch {
			// store ainda indisponível — segue só com pageStore
		}
	}

	if (!modoColetor) return;

	// Formulário sem meta de layout, em modo coletor → collector-option.
	to.meta.layout = "collector-option";
});
